import React from 'react'
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid, Card, IconButton, Button, Badge, Avatar } from '@material-ui/core';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/Notifications';

const useStyles = makeStyles(theme => ({

    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '0px 6px',
        marginBottom: 12
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    divTitle: {
        padding: 14,
    },
    divContent: {
        padding: 14,
    },
    cardBody: {
        // padding:20
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    avatar: {
        width: 40,
        height: 40
    },
    profileSection: {
        display: 'flex',
        alignItems: 'center'
    }
}));

export default function AppBarComp() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={classes.titleDiv}>
                <Typography variant="h2">App Bar</Typography>
            </div>
            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                App Bar
                        </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <AppBar position="static" color="transparent">
                                <Toolbar>
                                    <IconButton className={classes.menuButton} aria-label="menu">
                                        <MenuIcon />
                                    </IconButton>
                                    <Typography variant="h4" className={classes.title}>
                                        App Title
                                    </Typography>
                                    <Button color="inherit">Login</Button>
                                </Toolbar>
                            </AppBar>
                        </div>
                    </Card>
                </Grid>

                <Grid item xs={12} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" >
                                Colored
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <AppBar position="static" >
                                <Toolbar>
                                    <IconButton className={classes.menuButton} aria-label="menu" color="inherit">
                                        <MenuIcon />
                                    </IconButton>
                                    <Typography variant="h4" className={classes.title} color="inherit">
                                        App Title
                                    </Typography>
                                    <Button color="inherit">Login</Button>
                                </Toolbar>
                            </AppBar>
                        </div>
                    </Card>
                </Grid>

                <Grid item xs={12} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" >
                                App Bar with elements
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <AppBar position="static" >
                                <Toolbar>
                                    <IconButton className={classes.menuButton} aria-label="menu" color="inherit">
                                        <MenuIcon />
                                    </IconButton>
                                    <Typography variant="h4" className={classes.title} color="inherit">
                                        App Title
                                    </Typography>
                                    <div className={classes.profileSection}>
                                        <IconButton aria-label="show 11 new notifications" color="inherit">
                                            <Badge badgeContent={4} color="inherit">
                                                <NotificationsIcon />
                                            </Badge>
                                        </IconButton>
                                        <Avatar
                                            alt="image"
                                            src="/images/avatars/image91.jpg"
                                            className={classes.avatar}
                                        />
                                    </div>
                                </Toolbar>
                            </AppBar>
                        </div>
                    </Card>
                </Grid>

                <Grid item xs={12} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" >
                                App Bar with elements
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <AppBar position="static" color="transparent">
                                <Toolbar>
                                    <IconButton className={classes.menuButton} aria-label="menu" >
                                        <MenuIcon />
                                    </IconButton>
                                    <Typography variant="h4" className={classes.title} >
                                        App Title
                                    </Typography>
                                    <div className={classes.profileSection}>
                                        <IconButton aria-label="show 11 new notifications" color="inherit">
                                            <Badge badgeContent={4} color="primary">
                                                <NotificationsIcon />
                                            </Badge>
                                        </IconButton>
                                        <Avatar
                                            alt="image"
                                            src="/images/avatars/image91.jpg"
                                            className={classes.avatar}
                                        />
                                    </div>
                                </Toolbar>
                            </AppBar>
                        </div>
                    </Card>
                </Grid>


            </Grid>



        </div>
    )
}
